import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  filters: {
    display: 'flex',
    flexDirection: 'column',
    background: theme.palette.grey[200],
    padding: '8px 16px',
    marginTop: 8,
    borderRadius: 8
  },
  filterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  reset: { color: theme.palette.info.main, fontWeight: 500 },

  horizentalSeprator: {
    width: '100%',
    height: '1px',
    display: 'flex',
    justifyContent: 'center',
    background: theme.palette.grey[400],
    marginTop: 15,
    marginBottom: 15
  },
  search: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: 5,
    marginBottom: 5
  },
  filterText: { fontWeight: 600, color: theme.palette.grey[800] },
  switchLabel: { fontSize: 14, fontWeight: 500, marginLeft: 8 },
  switchContainer: { margin: '8px 0', padding: 8 }
}))
export default useStyles
